import React, { useState, useEffect } from "react";
import moment from "moment";
import Currency from "react-currency-formatter";
import ReactTooltip from "react-tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { analytics, logEvent } from '~/services/firebaseConfig'
import pix from '~/assets/images/pix-blue.svg';

import {
  Container,
  Title,
  ItemDetails,
  Left,
  Middle,
  Right,
  Details,
  PixContainer,
  ToolTipButton,
  ToolTipText,
  PixIcon,
} from "./styles";

import { handleStatus } from "~/utils/functions/bankSlips";
import information from "~/assets/images/icon-info-blue.svg";

export default function BankslipsMobile({ data, openModal }) {
  let status = handleStatus(data);
  const [selectedPixCode, setSelectedPixCode] = useState("")

  function handleCopyToClickBoard(selectedPixCode) {
    logEvent(analytics, "copiando_linha_digitavel")
    return setSelectedPixCode(selectedPixCode);
  }

  let qrcodeData = null;
  try {
    if ('qrcodeData' in data) {
      qrcodeData = JSON.parse('{' + data.qrcodeData + '}');
    }
  } catch (error) {
    console.log('Erro ao converter QRCode');
  }


  return (
    <Container className="mb-3">
      <Left>
        <Title>
          {moment(data.dueDate).format("MMMM/YYYY")}
        </Title>
        <ItemDetails>
          <span
            style={{
              fontSize: "10px",
              color:
                status === "Pago"
                  ? "#75B943"
                  : status === "Vencido"
                    ? "#e34e2a"
                    : status === "A Vencer"
                      ? "#f0b01b"
                      : "#000",
            }}
            className="mdi mdi-checkbox-blank-circle mr-1"
          />
          {status}
        </ItemDetails>
      </Left>

      <Middle>
        <Title>Vencimento: </Title>
        <ItemDetails>{moment(data.dueDate).format("DD/MM/YYYY")}</ItemDetails>
      </Middle>

      <Right>
        <Details onClick={() => openModal()}>
          <img src={information} alt="information" />
        </Details>
        <div style={{width: 25, height: 25}}>
          {status !== "Pago" && qrcodeData?.dados_qrcode?.emv && (
            <PixContainer>
              <CopyToClipboard text={qrcodeData?.dados_qrcode?.emv}>
                <ToolTipButton
                  onClick={() => handleCopyToClickBoard(qrcodeData?.dados_qrcode?.emv)}
                  data-tip
                  data-for={data.installmentId}
                >
                  <img src={pix} alt="Debito no pedido" style={PixIcon} />
                </ToolTipButton>
              </CopyToClipboard>
              {/* TODO - À primeira vista, o código abaixo pode parecer incorreto, mas no contexto de dispositivos móveis, essa é a única forma funcional. */}
              {selectedPixCode === qrcodeData?.dados_qrcode?.emv ? (
                <ReactTooltip id={data.installmentId} place="top" type="dark" effect="solid">
                  <ToolTipText>Copiado</ToolTipText>
                </ReactTooltip>
              ) : (
                <ReactTooltip id={data.installmentId} place="top" type="dark" effect="solid">
                  <ToolTipText>Copiado</ToolTipText>
                </ReactTooltip>
              )}
            </PixContainer>
          )}
        </div>
        <Title>
          <Currency quantity={data.amountOriginal} currency="BRL" locale="pt" />
        </Title>
      </Right>
    </Container>
  );
}
